import React from "react";
import { Link } from "react-router-dom";

// Style \\
import "../../assets/styles/cards/newsSectionCard.scss";

// Image \\
import Post from "../../assets/images/postImg.svg";

// Icons \\
import { MdOutlineCalendarToday } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import { FaRegHeart } from "react-icons/fa6";
import { FaRegUser } from "react-icons/fa";
import { LuEye } from "react-icons/lu";

const NewsSectionCard = () => {
  return (
    <div className="newsSectionCard">
      <div className="card_items">
        <div className="card_items_img">
          <img src={Post} alt="" />
        </div>

        <div className="card_items_info">
          <div className="data">
            <MdOutlineCalendarToday className="calendar" />
            <p>06.03.2023</p>
          </div>

          <div className="auth">
            <FaRegUser className="user" />
            <p>By Author</p>
          </div>

          <div className="watched">
            <LuEye className="eye" />
            <p>68</p>
          </div>
          <div className="liked">
            <FaRegHeart className="heart" />
            <p>86</p>
          </div>
        </div>

        <div className="text">
          <div className="title">
            <h4>A passion for putting patients first</h4>
          </div>

          <div className="desc">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              placerat scelerisque tortor ornare ornare. Quisque placerat
              scelerisque tortor ornare ornare Convallis felis vitae tortor
              augue. Velit nascetur proin massa in. Consequat faucibus porttitor
              enim et....
            </p>
          </div>

          <div className="readMore">
            <Link className="readMoreLink">
              Read More
              <span>
                <FaArrowRight className="arrow-icon" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsSectionCard;
